/**
 * ============================================================================
 * Factory 模块 - 常量定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义枚举标签映射（中文显示）
 * - 定义权限常量
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/System/Models/Factory.php (静态属性 $statusMap)
 * - Permissions: backend/database/seeders/PermissionSeeder.php
 * 
 * ⚠️ 注意事项：
 * - 标签对象命名：{MODULE}_{ENUM}_LABELS（全大写）
 * - 权限常量命名：{MODULE}_PERMISSIONS（全大写）
 * - 使用 `as const` 保证类型推断
 * - 枚举标签的 key 必须与 enums.ts 中的枚举值对应
 * 
 * 🔄 更新时机：
 * - enums.ts 新增枚举值时（同步新增标签）
 * - 后端权限定义变化时
 * - 中文标签需要修改时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Modules/System/Models/Factory.php
 * 2. 找到 public static $statusMap
 * 3. 检查本文件的 LABELS 对象是否包含所有映射
 * 4. 检查中文标签是否与后端一致
 * 5. 读取 PermissionSeeder.php，确认权限常量是否完整
 * 
 * @module types/factory/constants
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

import { FactoryStatus } from './enums'

/**
 * 工厂状态标签映射
 * 
 * 对应后端：Factory::$statusMap
 */
export const FACTORY_STATUS_LABELS = {
  [FactoryStatus.INACTIVE]: '停用',
  [FactoryStatus.ACTIVE]: '运营中',
} as const

/**
 * ⚠️ 工厂权限常量已迁移至统一权限管理
 * 
 * 请从 @bayes-mes/shared 导入标准权限常量：
 * - PERM_ORGANIZATION_FACTORY_VIEW
 * - PERM_ORGANIZATION_FACTORY_CREATE
 * - PERM_ORGANIZATION_FACTORY_UPDATE
 * - PERM_ORGANIZATION_FACTORY_DELETE
 * 
 * @deprecated 请使用 constants/api-permissions.ts 中的权限常量
 * @see bayes-mes-shared/constants/api-permissions.ts
 */

